<template>
  <section class="page">
    <div class="eyebrow">🧠 AI 口诀记忆生成</div>
    <div class="heading">
      <div>
        <h1>口诀记忆 · <em>把知识点变成顺口溜</em></h1>
        <p>输入医学知识点，AI 为你生成朗朗上口的核心记忆口诀与逐句详解</p>
      </div>
    </div>

    <div class="composer">
      <input
        v-model="topic"
        class="ai-input"
        placeholder="输入医学知识点，如：急性心肌梗死、COPD、甲亢危象…"
        :disabled="loading"
        @keyup.enter="generate"
      >
      <button class="btn" :disabled="loading || !topic.trim()" @click="generate">
        {{ loading ? '生成中…' : '✦ 生成口诀' }}
      </button>
    </div>

    <example-chips :examples="examples" @select="topic = $event" />

    <p class="hint">建议输入具体疾病/机制/药理条目，AI 会生成口诀 + 逐句医学释义 + 记忆技巧。</p>

    <gate-banner :error="gateError" />

    <empty-state
      v-if="!result && !loading && !error"
      icon="⚡"
      title="核心口诀"
      description="请在上方输入医学知识点，AI 将为你生成朗朗上口的核心记忆口诀与逐句详解…"
    />

    <ai-output-card
      v-else
      title="⚡ 核心口诀"
      :loading="loading"
      :error="error"
      :model="result && result.model"
      :mock="result && result.mock"
      :warning="result && result.warning"
      :updated="result && result.updated"
    >
      <template v-if="result && result.parsed">
        <article class="summary"><b>{{ result.parsed.mnemonic }}</b></article>
        <div class="cards">
          <article v-for="(line, i) in result.parsed.lines || []" :key="i">
            <h3><span>{{ i + 1 }}</span>{{ line.phrase }}</h3>
            <p>{{ line.explain }}</p>
          </article>
        </div>
        <div v-if="tips.length" style="margin-top: 14px">
          <div class="section-title">记忆技巧</div>
          <p v-for="(t, i) in tips" :key="i" class="hint" style="line-height: 2">💡 {{ t }}</p>
        </div>
      </template>
      <!-- parsed 缺字段兜底：直接展示原始文本 -->
      <template v-else-if="result && result.content">
        <p style="white-space: pre-wrap">{{ result.content }}</p>
      </template>
    </ai-output-card>
  </section>
</template>

<script>
import { callAI } from '../api';
import AIOutputCard from '../components/AIOutputCard.vue';
import EmptyState from '../components/EmptyState.vue';
import ExampleChips from '../components/ExampleChips.vue';
import GateBanner from '../components/GateBanner.vue';

export default {
  name: 'Mnemonic',
  components: { AIOutputCard, EmptyState, ExampleChips, GateBanner },
  data: () => ({
    topic: '急性心肌梗死',
    examples: ['急性心肌梗死', 'COPD', '甲亢危象', '消化性溃疡', '糖尿病酮症酸中毒'],
    loading: false,
    error: '',
    gateError: null,
    result: null,
  }),
  computed: {
    tips() {
      return (this.result && this.result.parsed && this.result.parsed.tips) || [];
    },
  },
  methods: {
    async generate() {
      if (!this.topic.trim() || this.loading) return;
      this.loading = true;
      this.error = '';
      try {
        const data = await callAI('mnemonic', { topic: this.topic.trim() });
        this.result = { ...data, updated: '刚刚更新' };
      } catch (e) {
        this.gateError = { code: e.code, msg: e.msg || e.message };
        this.error = this.gateError.msg;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
